export default {
}



// WEBPACK FOOTER //
// ./src/app/tenant/accountability/resources/components.js